import type { SliceInfo } from '../domain/RendererContract';

/**
 * React key of one block item on a rendered page. A block's FIRST slice shares the whole-block key
 * (LLAMS-610 DB-05): every content edit re-runs pagination (provisional "whole block" layout, then
 * the measured split), and a key that flipped between `full` and `0-n` would remount the item —
 * dropping the caret of an editor open on the page after every keystroke. Later slices stay keyed
 * by their range.
 */
export function pageItemKey(instanceId: string, pageIndex: number, slice: SliceInfo | undefined, indexOnPage: number): string {
  const range = slice && slice.startIndex > 0 ? `${slice.startIndex}-${slice.endIndex}` : 'full';
  return `${instanceId}:${pageIndex}:${range}:${indexOnPage}`;
}
